module.exports = __webpack_public_path__ + "img/Eduzz-7-es.62ea5320.png";